import { accountsViewLoadingSelector } from "./accountsViewLoadingSelector";
import { accountsSortByLoadingSelector } from "./accountsSortByLoadingSelector";
import { accountsOrderingLoadingSelector } from "./accountsOrderingLoadingSelector";
import { RootState } from "../../../store";
import { ProviderType } from "../../../../services/cloudchipr.api";
import { AccountTabs } from "../../../../components/pages/accounts-group/utils/types/types";

export const accountsNeededInfoLoadingSelector = (
  state: RootState,
  provider: ProviderType,
  tabValue: AccountTabs,
  orgId?: string,
) => {
  const sortByLoading = accountsSortByLoadingSelector(
    state,
    provider,
    tabValue,
    orgId,
  );
  const orderingLoading = accountsOrderingLoadingSelector(
    state,
    provider,
    tabValue,
    orgId,
  );
  const viewLoading = accountsViewLoadingSelector(
    state,
    provider,
    tabValue,
    orgId,
  );

  return sortByLoading || orderingLoading || viewLoading;
};
